import GentlingChecklist from '../shared/GentlingChecklist';
import { THEME_COLORS, GENTLING_CATEGORIES } from '../../../constants/horseConstants';

/**
 * Horse Training Card Component
 * Displays and manages gentling/training progress
 * @param {object} mustang - The mustang data
 * @param {function} onCheckboxChange - Callback for checkbox changes
 * @param {array} categories - Custom training categories (optional)
 */
const HorseTrainingCard = ({ mustang, onCheckboxChange, categories }) => {
  // Use custom categories if provided, otherwise fall back to constants
  const trainingCategories = categories && categories.length > 0 ? categories : GENTLING_CATEGORIES;
  
  // Count completed tasks based on the actual categories being used
  const countCompleted = () => {
    let count = 0;
    trainingCategories.forEach(category => {
      const categoryData = mustang.gentling?.[category.key] || {};
      category.items.forEach(item => {
        if (categoryData[item.key]) count++;
      });
    });
    return count;
  };
  
  const completedCount = countCompleted();

  return (
    <div className="space-y-4">
      {/* Progress Summary */}
      <div className="bg-gray-50 p-3 rounded-lg">
        <div className="text-sm font-medium mb-1" style={{ color: THEME_COLORS.primary }}>
          Training Progress
        </div>
        <div className="text-2xl font-bold" style={{ color: THEME_COLORS.secondary }}>
          {completedCount} tasks completed
        </div>
      </div>

      {/* Gentling Checklist */}
      <div>
        <h4 className="text-base font-semibold mb-2" style={{ color: THEME_COLORS.primary }}>
          Gentling Checklist
        </h4>
        <GentlingChecklist
          gentling={mustang.gentling || {}}
          categories={trainingCategories}
          onChange={(updatedGentling) => {
            // Find which item changed
            const categoryKeys = Object.keys(updatedGentling);
            for (const category of categoryKeys) {
              const items = Object.keys(updatedGentling[category] || {});
              for (const itemKey of items) {
                if (mustang.gentling?.[category]?.[itemKey] !== updatedGentling[category][itemKey]) {
                  onCheckboxChange(mustang, category, itemKey, updatedGentling[category][itemKey]);
                  return;
                }
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default HorseTrainingCard;
